"use strict";

exports.getOrganizationFromFull = function (full) {
    return full.restaurant || full.chain || full.portal || full.affiliate || full.distributor || full;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/Organization.js
// module id = 926
// module chunks = 0